import React, { Component } from 'react';
import firebase from '../../config/fbConfig';
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { createReviewMessage, backupReviewMessage, deleteReviewMessage, deleteReviewChat, deleteAdminReviewMessage } from '../../store/actions/restaurantActions'
import ReviewSummary from './ReviewSummary'

class MessengerReview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message:'',
      project:'',
      senderId:'',
      chat:'',
      sortedChat:'',
      newMessage:'',
      original:'',
      noDocument:false
    };
  }

  componentDidMount() {

    const ref = firebase.firestore().collection('users').doc(this.props.match.params.userId).collection('reviewMessages').doc(this.props.match.params.messageId);  
      ref.get().then((doc) => {
      if (doc.exists) {
        const messageDoc = doc.data();
        this.setState({
          newMessage:'',
          message:messageDoc.message,
          project:messageDoc.project,
          senderId:messageDoc.senderId
        });
      } else {
        console.log("No such document!");
        this.setState({
          noDocument:true
        });
      }
    });
    
  }


  componentDidUpdate(){

    if(this.state.project === '' && !this.state.noDocument){
      const ref = firebase.firestore().collection('users').doc(this.props.match.params.userId).collection('reviewMessages').doc(this.props.match.params.messageId);  
      ref.get().then((doc) => {
      if (doc.exists) {
        const messageDoc = doc.data();
        this.setState({
          newMessage:'',
          message:messageDoc.message,
          project:messageDoc.project,
          senderId:messageDoc.senderId
        });
      } else {
        console.log("No such document!");
        this.setState({
          noDocument:true
        });
      }
    });
    }

    if(this.props.restaurants && this.state.project !== '' && this.state.original===''){
      if(this.props.restaurants.find(x=>x.restaurantId===this.state.project.restaurantId) !== undefined){
        this.setState({original:this.props.restaurants.find(x=>x.restaurantId===this.state.project.restaurantId)})
      }
      else{
        this.setState({original:null})  
      }
    }


    if(document.getElementById("chatBoxContainer") && this.state.newMessage===""){
      var div = document.getElementById("chatBoxContainer");
      div.scrollTop = div.scrollHeight - div.clientHeight;
    }
    this.getMarker().then((chat)=>{
        if(JSON.stringify(this.state.chat) !== JSON.stringify(chat)){
          this.setState({
            chat:chat
          })
        }
      });

    if (!this.props.message){
      if(this.state && this.state.project !== ''
      ){this.setState({
      message:'',
      project:'',
      senderId:'',
      chat:'',
      sortedChat:''})}
    }
    
    
  }

  async getMarker() {
    const snapshot = await firebase.firestore().collection('users').doc(this.props.match.params.userId).collection('reviewMessages').doc(this.props.match.params.messageId).collection('chat').get()
    return snapshot.docs.map(doc => doc.data());
  }

  
  onFavorite = (project) => {
    console.log('no favorites');
   }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  closeFunction =(e)=>{document.getElementById("deleteModal").style.display = "none";}

  messageDeleteInterruptor =(e)=>{
    e.preventDefault();
    document.getElementById("deleteModal").style.display = "block";
  }

  onEnterPress = (e) => {
  if(e.keyCode === 13 && e.shiftKey === false) {
    e.preventDefault();
    this.handleMessageConfirm(e);
  }
  }

  handleDelete = (e) => {
    e.preventDefault();
    this.props.backupReviewMessage(this.props.match.params.userId,this.props.match.params.messageId, this.state, ()=>{
      this.setState({
      message:'',
      project:'',
      senderId:'',
      chat:'',
      sortedChat:''});    
    });
    this.props.deleteReviewMessage(this.props.match.params.userId,this.props.match.params.messageId);
    
    if (this.props.chat){
      for (let key of Object.keys(this.props.chat)){
        if(key!==this.props.match.params.messageId ){
          this.props.deleteReviewChat(this.props.match.params.userId, this.props.match.params.messageId, key);
        }   
      }  
    }
    
    if(this.props.match.params.adminMessageId){
    this.props.deleteAdminReviewMessage(this.props.match.params.adminMessageId);  
    }
    
    document.getElementById("deleteModal").style.display = "none";
    console.log(this.props.match.params.adminMessageId);
    if(this.props.match.params.adminMessageId==='null'){this.setState({redirect:true});}
    else{this.setState({redirectAdmin:true})}
  }

  handleAdminDelete = (e)=>{
    if(this.props.match.params.adminMessageId!=='null'){
      this.props.deleteAdminReviewMessage(this.props.match.params.adminMessageId);
      this.setState({redirectAdmin:true})  
    }
  }


  handleMessageConfirm = (e)=>{
    e.preventDefault();
    this.props.createReviewMessage(this.state.newMessage, this.props.match.params.userId, this.props.match.params.messageId, this.props.auth.uid)
    this.setState({newMessage:''});
    document.getElementById("newMessage").focus(); 
  }

  
  render() {
    const { auth, restaurants } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />
    if (this.state.redirectAdmin) return <Redirect to={'/AdminDashboard/'} />
    if (this.state.redirect) return <Redirect to={'/UserDashboard/'+this.props.auth.uid} />

      //this sorting stuff should be done with states in componentDidUpdate, not in render()
    var sortable = [];
          sortable.push([{'message':this.state.message, 'senderId':this.state.senderId},0]);
          for (var mess in this.state.chat){
            if(this.state.chat[mess] && this.state.chat[mess]['timestamp']){
              sortable.push([this.state.chat[mess],this.state.chat[mess]['timestamp'].seconds]);
            }
          }
          sortable.sort(function(a, b) {
           return a[1] - b[1];
          });
    var sorted = []
    for (var entry of sortable.entries()){
      if(entry[1][0].senderId === auth.uid){

        sorted.push([
        <div className='message' key={'message ' + entry[0]}>
        <p className='message-left' id={'message ' + entry[0]} >{entry[1][0].message}</p>
        </div>
        ]);
      }
      else{
        sorted.push([
          <div className='message2' key={'message ' + entry[0]} >
          <p className='message-right' id={'message ' + entry[0]} >{entry[1][0].message}</p>
          </div>
        ]);
      }
    }

    var whoPosted = [];
    var canMessage = false;

    if(sortable.slice(-3) && sortable.slice(-3).length === 3){
      for(var entry of sortable.slice(-3).entries()){
        whoPosted.push(entry[1][0]['senderId']);
      }
      canMessage = !(whoPosted[0] === whoPosted[1] && whoPosted[1] === whoPosted[2])
    }
    else if(sortable){
      canMessage = true
    }
    
    return (
      <div className = "outerMessageContainer">
      {this.state.noDocument &&
        <div>
        <p style={{"display": "flex", "justifyContent": "center"}}> This message has been archived.</p>
        <div style = {{"width":"100%","display": "flex", "justifyContent": "center"}}>
        <button className="btn pink lighten-1" onClick={this.handleAdminDelete}>Archive</button>
        </div>
        </div>
      }
      <div/>
      <div className="messageContainer">
            <div id="deleteModal" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunction}>&times;</span>
                <p>Are you sure you want to archive this chat?</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDelete}>Archive</button>
                </div>
              </div>
            </div>

      { this.state.project !== '' && restaurants && 
        <div className='messenger' >
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={this.messageDeleteInterruptor}>Archive</button>
          </div>
          <h5> Welcome to a chat concerning your review of  </h5>
          <div className="container-test">
            <ReviewSummary project={ this.state.project } showOnStart={true} original={restaurants.find(x=>x.restaurantId===this.state.project.restaurantId)} />
          {/*<RestaurantSummary key = { this.state.project.id } allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={this.state.project} favorite = {false}/>*/}
          </div>
        </div>
      }

      



      <div className="chatContainer">
      { this.state.chat !== '' && this.state.project !== '' &&
        <div>
          <h5 style={{"display": "flex", "justifyContent": "center"}}>Chat</h5>
          <div className="chatBoxContainer" id="chatBoxContainer">
            <div className="chatBox" id="chatBox">
            {
              sorted && sorted
            }
            </div>
          </div>
        </div>
      }

      { canMessage && this.state.project !== '' &&
        <div>
        <form className="white" autoComplete="off">
            <div className="input-field">
              <textarea id="newMessage" onKeyDown={this.onEnterPress} value={this.state.newMessage} onChange={this.handleChange}></textarea>
              <label className='active' htmlFor="message">Message</label>
            </div>
        </form>
        <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
          <button className="btn pink lighten-1" onClick={this.handleMessageConfirm}>Submit</button>
        </div>
        </div>
      }
      { !canMessage && 
        <div style={{textAlign:"center"}}>
        <p>There is a limit of 3 messages without a response.</p>
        <p>Please try to keep messages clear and concise.</p>
        </div>
      }
      </div>
      </div>

      <div name="b"/>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    restaurants: state.firestore.ordered.restaurants,
    auth: state.firebase.auth,
    chat: state.firestore.data.reviewChat,
    message: state.firestore.data.reviewMessage
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createReviewMessage: (message, userId, messageId, senderId) => dispatch(createReviewMessage(message, userId, messageId, senderId)),
    backupReviewMessage: (userId, messageId, message, callback) => dispatch(backupReviewMessage(userId, messageId, message, callback)),
    deleteReviewMessage: (userId, messageId) => dispatch(deleteReviewMessage(userId, messageId)),
    deleteReviewChat: (userId, messageId, chatId) => dispatch(deleteReviewChat(userId, messageId, chatId)),
    deleteAdminReviewMessage: (adminMessageId) => dispatch(deleteAdminReviewMessage(adminMessageId))

  }
}

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  firestoreConnect(props =>{
    const userId = props.auth.uid
    if(!userId){
      return []
    }
    return[
    { collection: 'restaurants'},
    {
      collection: 'users',
      doc: props.match.params.userId,
      subcollections: [
        { collection: 'reviewMessages',
          doc: props.match.params.messageId,
          subcollections: [
            { collection: 'chat' }
            ]    
         }
      ], storeAs: 'reviewChat'
    },
    {
      collection: 'users',
      doc: props.match.params.userId,
      subcollections: [
        { collection: 'reviewMessages',
          doc: props.match.params.messageId    
         }
      ], storeAs: 'reviewMessage'
    }

  ]})
)(MessengerReview)
